import Swal from 'sweetalert2';
import React, { useEffect, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import toast from 'react-hot-toast';

const base_url = process.env.REACT_APP_API_URL;

const CashoutHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [history, setHistory] = useState([]);
  const [originalHistory, setOriginalHistory] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [pendingTotal, setPendingTotal] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchHistory = async () => {
    const auth = localStorage.getItem('admin');
    try {
      const response = await axios.get(base_url + '/api/webapi/cashoutHistory', {
        headers: {
          Accept: 'application/json',
          Authorization: `${auth}`
        }
      });
      if (response?.data.success) {
        setHistory(response.data.data);
        setOriginalHistory(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching history:', error);
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '') {
      setHistory(originalHistory);
      setPendingTotal(null);
    } else {
      const filterData = originalHistory.filter((val) =>
        val.phone.toString().includes(inputValue)
      );
      setHistory(filterData);
      setPendingTotal(null);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.text('My Bet History', 14, 15);

    const tableData = history.map((data) => [
      data.phone,
      data.competitionName,
      data.eventName,
      data.side,
      data.betprice,
      data.betAmount,
      data.profit,
      data.status === 1 ? 'Win' : data.status === 2 ? 'Loss' : 'Running',
      data.ip,
      data.date
    ]);

    autoTable(doc, {
      startY: 20,
      head: [
        ['User ID', 'Tournament', 'Match', 'Side', 'Odds', 'Stake', 'P/L', 'Status', 'IP', 'Date']
      ],
      body: tableData
    });

    doc.save('bet-history.pdf');
  };

  const handleFilterByDate = () => {
    if (!fromDate || !toDate) {
      setHistory(originalHistory);
      setPendingTotal(null);
      return;
    }

    const filtered = originalHistory.filter((bet) => {
      const betDate = new Date(bet.date).toISOString().split('T')[0];
      return betDate >= fromDate && betDate <= toDate;
    });

    setHistory(filtered);
    setPendingTotal(null);
  };

 const handleDelete = async (phone, betAmount, betId) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: "This bet will be deleted and amount refunded!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });

  if (result.isConfirmed) {
    try {
      await axios.post(`${base_url}/api/webapi/deleteBet`, {
        phone,
        betAmount,
        betId,
      });

      const updatedHistory = history.filter((bet) => bet.id !== betId);
      setHistory(updatedHistory);
      setOriginalHistory(updatedHistory);

      toast.success("Bet deleted and cashout successful!");
    } catch (error) {
      console.error("Error deleting bet:", error);
      toast.error("Failed to delete bet");
    }
  }
};


  const resetFilters = () => {
    setFromDate('');
    setToDate('');
    setHistory(originalHistory);
    setPendingTotal(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchHistory();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   return (
    <div className="wrapper">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper ${!isMobile && isSidebarOpen ? '' : 'open-content-wrapper'}`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? '' : '0',
          transition: 'margin-left 0.3s ease',
          padding: '20px',
          backgroundColor: '#f8f9fa',
          minHeight: '100vh'
        }}
      >
        <section className="content-header">
          <h1 className="fw-bold text-primary">Cashout History</h1>
          <hr style={{ borderColor: '#dee2e6' }} />
        </section>

        <div className="container-fluid">
          <div className="card shadow-sm border-0 rounded-3 p-4 bg-white">
            <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center mb-4">
              <input
                type="text"
                placeholder="Search by User ID"
                className="form-control flex-grow-1"
                style={{ maxWidth: '320px', minWidth: '220px' }}
                onChange={handleChange}
              />

              <div className="d-flex gap-2 flex-wrap">
                <button className="btn btn-primary px-4" onClick={handleDownloadPDF}>
                  <i className="bi bi-download me-2"></i>Download PDF
                </button>

                {/* <button
                  className="btn btn-warning px-4"
                  onClick={() => {
                    const filtered = originalHistory.filter(
                      (bet) => bet.status !== 1 && bet.status !== 2
                    );
                    setHistory(filtered);
                    const total = filtered.reduce(
                      (sum, bet) => sum + parseFloat(bet.betAmount),
                      0
                    );
                    setPendingTotal(total);
                  }}
                >
                  <i className="bi bi-clock-history me-2"></i>Show Pending Bets
                </button> */}
              </div>
            </div>

            <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
              <label className="fw-semibold mb-0">From:</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                style={{ maxWidth: '170px' }}
              />

              <label className="fw-semibold mb-0">To:</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                style={{ maxWidth: '170px' }}
              />

              <button className="btn btn-info px-4" onClick={handleFilterByDate}>
                <i className="bi bi-filter-circle me-2"></i>Filter
              </button>
              <button className="btn btn-secondary px-4" onClick={resetFilters}>
                <i className="bi bi-arrow-clockwise me-2"></i>Reset
              </button>
            </div>

            {pendingTotal !== null && (
              <div className="alert alert-success fw-bold fs-5" role="alert">
                Total Pending Stake: <span className="text-success">₹{pendingTotal.toFixed(2)}</span>
              </div>
            )}

            <div className="table-responsive shadow-sm rounded">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: '1000px' }}>
                <thead className="table-light sticky-top" style={{ top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center">User ID</th>
                    <th className="text-center">Tournament Name</th>
                    <th className="text-center">Match Name</th>
                    <th className="text-center">Side</th>
                    <th className="text-center">Odds</th>
                    <th className="text-center">Stake</th>
                    <th className="text-center">P/L</th>
                    <th className="text-center">Bet Status</th>
                    <th className="text-center">IP</th>
                    <th className="text-center">Place Date</th>
                    {/* <th className="text-center">Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {history.length === 0 ? (
                    <tr>
                      <td colSpan="11" className="text-center text-muted py-4">
                        No bets found
                      </td>
                    </tr>
                  ) : (
                    history.map((data) => (
                      <tr key={data.id} style={{ cursor: 'default' }}>
                        <td className="text-center">{data.phone}</td>
                        <td className="text-start">{data.competitionName}</td>
                        <td className="text-start">{data.eventName}</td>
                        <td className="text-center">
                          <span
                            className="badge"
                            style={{
                              backgroundColor:
                                data.side === 'Back' ? 'rgb(114, 125, 206)' : 'rgb(237, 95, 95)',
                              color: 'white',
                              padding: '6px 12px',
                              fontWeight: '600',
                              borderRadius: '12px',
                            }}
                          >
                            {data.side}
                          </span>
                        </td>
                        <td className="text-center">{data.betprice}</td>
                        <td className="text-center">{data.betAmount}</td>
                        <td
                          className="text-center fw-semibold"
                          style={{
                            color:
                              data.status === 3
                                && 'rgb(187, 70, 3)'
                          }}
                        >
                          {data.profit}
                        </td>
                        <td className="text-center">
                          <span
                            className="badge"
                            // style={{
                            //   backgroundColor:
                            //     data.status === 1
                            //       ? 'rgb(3, 187, 22)'
                            //       : data.status === 2
                            //       ? 'rgba(255,0,0,1)'
                            //       : 'gray',
                            //   color: 'white',
                            //   fontWeight: '600',
                            //   padding: '6px 12px',
                            //   borderRadius: '12px',
                            // }}
                          >
                            {data.status === 3 && 'Cashout Completed'}
                          </span>
                        </td>
                        <td className="text-center">{data.ip}</td>
                        <td className="text-center">{data.date}</td>
                        {/* <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(data.phone, data.betAmount, data.id)}
                            title="Delete Bet"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="mb-5" />
      </div>
    </div>
  );
};

export default CashoutHistory;
